<template>
  <!-- 国家教学标准 -->
  <div class="generalBg">
    <div class="header">
      <div class="header_Virtualization"></div>
      <div class="header_title">
        <i class="h_icon header-icon"></i>
        <span>国家教学标准</span>
      </div>
      <i class="threePoints el-icon-more"></i>
      <span class="grey download" @click="downloads">
        <i class="h_icon icon-clip"></i>
        下载文档
      </span>
    </div>
    <div class="standards_content" style="overflow-y: auto;">
      <div class="content">
        <el-collapse v-model="activeNames">
          <el-collapse-item :name="index" v-for="(item,index) in standardsList" :key="index">
            <template slot="title">
              <i class="cheader_icon"></i>
              {{item.name}}
            </template>
            <div v-if="item.child">
              <div v-for="(e,i) in item.child" :key="i">
                <h4>
                  <div>
                    <b class="subscript">
                      {{numberList[i]}}
                      <span>{{e.name}}</span>
                    </b>
                  </div>
                </h4>
                <p class="indent" v-show="e.name === '专业课程'">一般包括专业基础课程、专业核心课程、专业拓展课程，并涵盖有关实践性教学环节。</p>
                <p class="indent" v-show="e.name === '专业课程'">学校自主确定课程名称，但应包括以下主要教学内容：</p>
                <div v-for="(items,indexs) in e.substance" :key="indexs">
                  <div v-html="items"></div>
                </div>
              </div>
            </div>

            <div v-if="item.content" v-html="item.content"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: [0, 1, 2, 3, 4, 5],
      standardsList: [],
      numberList: ['ONE', 'TOW', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'ENGHT', 'NINE', 'TEN', 'ELEVEN', '', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIVETEEN', 'SIXTEEN', 'SEVENTEEN', 'ENGHTEEN', 'NINETEEN', 'TWENTY', 'TEENTY-ONE', 'TEENTY-TOW', 'TEENTY-THREE', 'TEENTY-FOUR', 'TEENTY-FIVE', 'TEENTY-SIX', 'TEENTY-SEVEN', 'TEENTY-NIGHT', 'TEENTY-NINE', 'THIRTY', 'THIRTY-ONE', 'THIRTY-TOW', 'THIRTY-THREE', 'THIRTY-FOUR', 'THIRTY-FIVE'],
      fileId: null
    }
  },
  created() {
    this.getProfessionStandard()
  },
  methods: {
    getProfessionStandard() {
      this.$axios.post(this.$apiurls.standards_getProfessionStandard, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.fileId = res.data[0].fileId
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].child) {    //处理带有子节点的内容
              for (let j = 0; j < res.data[i].child.length; j++) {
                if (res.data[i].child[j].name === '专业课程') {   //单独处理专业课程内容
                  var special = res.data[i].child[j].content.split('.')   //根据数字后面的点进行分割
                  var modification = ""
                  for (let p = 0; p < special.length; p++) {
                    if (p != special.length - 1) {
                      special[p] = special[p].substring(0, special[p].length - 1) + '</p><p class="indent">' + special[p].slice(-1) + '.'
                    }
                    modification += special[p]
                  }
                  res.data[i].child[j].content = modification
                }
                var firstsplit = res.data[i].child[j].content.split('；');
                var arrList = []
                for (let k = 0; k < firstsplit.length; k++) {
                  arrList.push(firstsplit[k] = `<p class="indent">${firstsplit[k]}</p>`)
                }
                res.data[i].child[j].substance = arrList
              }
            }

            if (res.data[i].content) {        //处理没有子节点内容
              var src = ''
              var contents = res.data[i].content.split('.')
              if (contents.length > 1) {
                for (let i = 0; i < contents.length; i++) {
                  if (i == 0) {
                    contents[i] = contents[i] + '.' + contents[i + 1].substring(0, contents[i + 1].length - 1)
                    src = `<p class="indent">${contents[i]}</p>`
                  } else if (i != 0 && i != contents.length - 1) {
                    contents[i] = contents[i].substring(contents[i].length - 1, contents[i].length) + '.' + contents[i + 1].substring(0, contents[i + 1].length - 1)
                    src += `<p class="indent">${contents[i]}</p>`
                  }
                }
              } else {
                src = `<p class="indent">${contents[0]}</p>`
              }
              res.data[i].content = src
            }
          }
          this.standardsList = res.data
        }
      });
    },
    // 下载文档
    downloads() {
      // window.open(`${this.$apiurls.downloadTeachStandard}?fileId=${this.fileId}`)
      const professional = sessionStorage.getItem("professional")
      window.open("http://101.201.126.223:9006/lrmv2_file/standard/"+professional+".pdf")
    }
  }
}
</script>

<style lang="scss" scoped >
.generalBg {
  width: 100%;
  height: 100%;
  position: relative;
  color: #fff;
  padding-bottom: 45px;
}

.header {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  border-radius: 4px 4px 0px 0px;
  position: relative;
}
.header_title {
  padding-left: 10px;
  font-size: 14px;
  text-align: center;
}
.el-icon-more {
  padding-right: 10px;
}

.header_title i {
  padding-right: 10px;
  font-size: 15px;
}

.content {
  width: 80%;
  height: 100%;
  margin: 30px auto 0px;
  p {
    line-height: 2;
  }
}

// 头部
.el-collapse {
  border: 0px;
}
.cheader_icon {
  width: 6px;
  height: 24px;
  background: #1bf6f8;
  border-radius: 2px;
  margin-right: 10px;
}
.content ::v-deep .el-collapse-item__header {
  font-size: 24px;
  font-weight: bold;
  line-height: 24px;
  color: #ffffff;
  background: linear-gradient(
    270deg,
    rgba(38, 161, 255, 0.2) 0%,
    rgba(27, 246, 248, 0) 100%
  );
  border-radius: 4px;
  border: 0px;
}

.content ::v-deep .el-collapse-item__wrap {
  background: transparent;
  border: 0px;
}

.content ::v-deep .el-collapse-item__content {
  color: #94a3c1;
  font-size: 15px;
}

.content h4 {
  position: relative;
  padding-left: 15px;
  margin-top: 0px;
  margin-bottom: -20px;
}

.subscript {
  display: inline-block;
  font-size: 42px;
  font-weight: normal;
  font-family: "youshebiaotihei";
  background-image: linear-gradient(
    180deg,
    #127b8a,
    #0f6273,
    #0e5366,
    #0b2b41,
    #091029,
    #091029,
    #091029
  );
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  position: relative;
}

.subscript span {
  color: rgba(255, 255, 255, 0.836);
  font-weight: normal;
  font-size: 16px;
  font-family: "";
  position: absolute;
  left: 80%;
  top: 55%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
}

::v-deep.content .indent {
  padding-left: 15px;
}

::v-deep.content .indentation {
  text-indent: 30px;
}

.el-collapse-item {
  margin: 8px 0px;
}

.download {
  position: relative;
  z-index: 1;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.download i {
  margin-right: 3px;
}

.el-collapse-item__header.focusing:focus:not(:hover) {
  color: #fff;
}
</style>
